import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MessageBar, MessageBarType } from '@fluentui/react';
import { ErrorContent, } from '../../input/ErrorContent/ErrorContent';
/** Canned MessageBar for displaying errors complete with inner content handlers */
export const MessageError = ({ error, footer, titleContent, }) => (_jsxs(MessageBar, Object.assign({ messageBarType: MessageBarType.error, isMultiline: true }, { children: [titleContent, _jsx(ErrorContent, { error: error }), footer] })));
